import { daily } from "./index";

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function fetchCalendarInfo() {
  return daily.post('cal.do', {})
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function checkAttendance() {
  return daily.post('check.do', {})
  .then((res) => {
    return checkLimitedUser(res)
  })
}

export { fetchCalendarInfo, checkAttendance }